import {SectionInterface, SideTypeWithoutTop} from "../../../../../../store/types/store";
import {Content, Size, TableCell} from "pdfmake/interfaces";
import {lineColor, primaryColor} from "../../../../consts";
import {SectionListElement} from "../../../../getPDFPages";
import {ISectionLabelRow} from "../../../../types";

const getShelvingView = (side?: SideTypeWithoutTop): string => {
    let shelvingView = ''
    if (!side) {
        return ''
    }
    if (side === 'left') {
        shelvingView = `Слева`
    }
    if (side === 'right') {
        shelvingView = `Справа`
    }
    if (side === 'front') {
        shelvingView = `Спереди`
    }
    if (side === 'back') {
        shelvingView = `Сзади`
    }
    return shelvingView
}

export interface ISpecificationTableOneRowParameters extends ISectionLabelRow  {
    section?: SectionListElement
    sectionIndexText?: string
    isLastRowInPage?: boolean
    isLastRowInSection?: boolean
}

interface ISpecificationItemRowParameters {
    borderParameters: {
        border: boolean[], borderColor: string[]
    },
    fontSize: number
    name?: string
    count?: number,
    margin?: number[],
    isBold?: boolean
    isRed?: boolean,
    widths?: '*' | 'auto' | Size[] | undefined //3 столбца у нас.
}

const getSpecificationItemRow = (parameters: ISpecificationItemRowParameters): TableCell => {
    const {borderParameters, isBold, isRed, margin, name, count, fontSize, widths} = parameters
    return ({
        ...borderParameters,
        alignment: 'left',
        style: 'tableExample',
        margin,
        table: {
            widths: widths ? widths : [Boolean(count) ? 'auto' : 190, '*', 50],
            body: [[
                {
                    border: [false, false, false, false],
                    color: isRed ? '#EB3D00' : primaryColor,
                    text: name,
                    alignment: 'left',
                    bold: isBold,
                    fontSize: isRed ? fontSize - 3 : fontSize,
                    margin: [0, 0, 5, 0],
                },
                // {
                //     border: [false, false ,false ,false],
                //     table: {
                //         widths: '*',
                //         body: [[
                //             {
                //                 border: [false, false, false, Boolean(count)],
                //                 alignment: 'left',
                //                 margin,
                //                 bold: isBold,
                //                 fontSize: fontSize,
                //                 text: '',
                //             },
                //         ]]
                //     },
                //     layout: {
                //         hLineStyle: function (i, node) {
                //             return {dash: {length: 2, space: 1}};
                //         },
                //
                //         hLineColor: function (i, node) {
                //             return primaryColor;
                //         },
                //
                //     }
                // },
                {
                    border: [false, false, false, Boolean(count)],
                    alignment: 'left',
                    margin,
                    bold: isBold,
                    fontSize: fontSize,
                    text: '',
                },
                {
                    border: [false, false, false, false],
                    alignment: 'left',
                    fontSize: fontSize,
                    margin: [5, 0, 0, 0],
                    bold: isBold,
                    text: count ? `${count} шт.` : '',
                }
            ]]
        },
        layout: {
            paddingTop: (columnIndex, node) => {
                return 0
            },
            paddingBottom: (columnIndex, node) => {
                return 0
            },
            paddingLeft: (columnIndex, node) => {
                return 0
            },
            paddingRight: (columnIndex, node) => {
                return 0
            },
            hLineStyle: function (i, node) {
                return {dash: {length: 2, space: 1}};
            },
            hLineColor: function (i, node) {
                return primaryColor;
            },
        }
    })
}

export const getSpecificationTableBodyOneRow = (parameters: ISpecificationTableOneRowParameters): Content => {
    const productTableBody: Content = [];
    const {
        section,
        sectionIndexText,
        itemLabel,
        itemsCount,
        remainedLabel,
        remainedCount,
        isBoldItemLabel,
        isRedRemainedLabel,
        isLastRowInSection,
        isLastRowInPage
    } = parameters
    const side = section?.side

    const tableFontSize = 12;
    const border = {
        border: isLastRowInSection ? [false, false, false, true] : [false, false, false, false],
        borderColor: [primaryColor, primaryColor, primaryColor, primaryColor]
    }

    const margin = [0, 0, 0, 0]

    const getSectionSizes = (section?: SectionInterface) => {
        if (!section) {
            return ''
        } else {
            return `${section.width}x${section.height > section.leftRackHeight ? section.height : section.leftRackHeight}мм`
        }
    }


    const body: Content = {
        color: primaryColor,
        lineHeight: 1,
        margin: [20, 0, 20, 0],
        ...(isLastRowInPage ? {pageBreak: 'after'} : {}),
        table: {
            widths: [60, 50, 100, '*', '*'],
            heights: 13,
            body: [
                [
                    {
                        ...border,
                        text: sectionIndexText,
                        alignment: 'center',
                        fontSize: tableFontSize,
                        bold: isBoldItemLabel,
                        margin,
                    },
                    {
                        ...border,
                        alignment: 'left',
                        text: getShelvingView(side),
                        fontSize: tableFontSize,
                        bold: false,
                        margin,

                    },
                    {
                        ...border,
                        alignment: 'left',
                        text: getSectionSizes(section),
                        fontSize: tableFontSize,
                        bold: false,
                        margin,
                    },
                    getSpecificationItemRow({
                        borderParameters: border,
                        fontSize: tableFontSize,
                        name: itemLabel,
                        count: itemsCount,
                        margin,
                        isRed: false,
                        isBold: isBoldItemLabel,
                    }),
                    getSpecificationItemRow({
                        borderParameters: border,
                        fontSize: tableFontSize,
                        name: remainedLabel,
                        count: remainedCount,
                        margin,
                        isRed: isRedRemainedLabel,
                        isBold: false,
                        widths: ['auto', '*', 50]
                    })
                ]
            ],
        },
        layout: {
            paddingTop: () => {
                return 0
            },
            paddingBottom: () => {
                return 0
            },
            hLineColor: function (i, node) {
                return lineColor;
            },
            vLineColor: function (i, node) {
                return lineColor;
            },
        }
    };

    productTableBody.push(body);

    return productTableBody
}
